import { apiGet } from '@/store/api';
import { useHelperStore } from '@/store/helperStore';

export async function getDocumentLabels() {
  const data = await apiGet('helper/documentLabels');
  useHelperStore().setDocumentLabels(data);
}
